import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { SeccionId, primeraRuta, seccionesEfectivas } from '../lib/permisos';

/**
 * Guarda rutas autenticadas.
 *  - `seccion`: la sección (o las secciones, cualquiera de ellas) que hay que poder abrir (Administración → Permisos).
 *    Si no, a la PRIMERA sección que sí abre — la misma regla que el menú y que el API (api/src/lib/permisos.ts).
 *  - `roles` (lo de antes) sigue sirviendo para restringir por rol.
 */
export function ProtectedRoute({ children, roles, seccion }: { children: ReactNode; roles?: string[]; seccion?: SeccionId | SeccionId[] }) {
  const { user, loading } = useAuth();
  if (loading) {
    return <div style={{ display: 'grid', placeItems: 'center', height: '100%' }} className="muted">Cargando…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  const secciones = seccionesEfectivas(user);
  if (roles && roles.length > 0 && !roles.includes(user.role)) {
    return <Navigate to={primeraRuta(secciones)} replace />;
  }
  if (seccion && !(Array.isArray(seccion) ? seccion : [seccion]).some((s) => secciones.includes(s))) {
    return <Navigate to={primeraRuta(secciones)} replace />;
  }
  return <>{children}</>;
}
